//Custom components
import { countDuplicateStringsInArray } from 'utils';
import Card from '../../UI/Card';

//Assets and Miscellaneous

export default function FBDIGoalsSummary({ data }: { data: string[] }) {
  const fbdiGoalsSummary: { name: string; count: number }[] =
    countDuplicateStringsInArray(data);

  return (
    <>
      <Card title='FBDI Goals Summary'>
        <div className='h-96 overflow-scroll'>
          {fbdiGoalsSummary?.map((s: { name: string; count: number }) => (
            <div
              key={s?.name}
              className='flex justify-between gap-4 py-5 px-10 border-b'
            >
              <span>{s?.name}</span>
              <span className='text-xl font-bold'>{s?.count}</span>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
}
